/**
 * Hint temporar după POST /login: același `is_admin` ca la server.
 * Rămâne până când GET /me confirmă `is_admin` sau la logout.
 */

export const LOGIN_ADMIN_HINT_KEY = "aifp_login_is_admin_hint";

export function storeLoginAdminHint(isAdminFromLogin: boolean | undefined): void {
  try {
    if (typeof sessionStorage === "undefined") return;
    if (isAdminFromLogin === undefined) return;
    sessionStorage.setItem(
      LOGIN_ADMIN_HINT_KEY,
      isAdminFromLogin === true ? "true" : "false",
    );
  } catch {
    /* private mode / quota */
  }
}

export function clearLoginAdminHint(): void {
  try {
    if (typeof sessionStorage === "undefined") return;
    sessionStorage.removeItem(LOGIN_ADMIN_HINT_KEY);
  } catch {
    /* ignore */
  }
}

/** true / false dacă există hint; null dacă lipsește */
export function getLoginAdminHint(): boolean | null {
  try {
    if (typeof sessionStorage === "undefined") return null;
    const v = sessionStorage.getItem(LOGIN_ADMIN_HINT_KEY);
    if (v === null) return null;
    return v === "true";
  } catch {
    return null;
  }
}
